"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/SubscriptionsTab/components/Wrapper.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _useStatefulPromise = require('shared/hooks/useStatefulPromise');
var _time = require('shared/services/time');

var _Form = require('web/components/Form');
var _Spinner = require('web/components/Spinner');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);













const Wrapper = ({
  children,
  isLoading,
  hasLoadFailed,
  supportUrl,
  canManage,
  onManage,
  isLocked,
  hasItems,
  cancelAt,
}) => {
  const {
    isLoading: isManageLoading,
    run: handleManage,
  } = _useStatefulPromise.useStatefulPromise.call(void 0, onManage)

  if (isLocked && !cancelAt && !hasItems) {
    return (
        _react2.default.createElement('div', { className: "settings--org-subs--preloader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
          , _react2.default.createElement('span', { className: "settings--org-subs--error-subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "Please contact support to make changes to this organization's plan."

          )
        )
    )
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        _react2.default.createElement('div', { className: "settings--org-subs--preloader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
          , _react2.default.createElement(_Spinner.SimpleSpinner, { className: "settings--org-subs--loader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
        )
      )
    }

    if (hasLoadFailed) {
      return (
        _react2.default.createElement('div', { className: "settings--org-subs--preloader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          , _react2.default.createElement('h1', { className: "settings--org-subs--error-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Failed to load your plans"    )
          , _react2.default.createElement('span', { className: "settings--org-subs--error-subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Try again later or contact "
                 , ' '
            , _react2.default.createElement('a', { href: "mailto:support@bloomtext.com", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "support@bloomtext.com")
          )
        )
      )
    }

    return children
  }

  return (
    _react2.default.createElement('div', { className: "settings--org-subs--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
      ,  cancelAt && (
        _react2.default.createElement(_WarningBar2.default, {
          theme: "warning",
          text: `This plan will be canceled on ${_time.formatReadableDisplayDate.call(void 0, cancelAt)}`,
          className: "settings--org-subs--cancel-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
        )
      )
      ,  isLocked && !cancelAt && hasItems && (
        _react2.default.createElement(_WarningBar2.default, {
          theme: "warning",
          text: "Please contact support to make changes to this organization's plan."         ,
          className: "settings--org-subs--cancel-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
        )
      )
      , _react2.default.createElement('div', { className: "settings--org-subs--title-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
        , _react2.default.createElement('h2', { className: "settings--org-subs--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Features")
        ,  canManage && (
          _react2.default.createElement(_Form.Button, {
            isInverted: true,
            isLoading: isManageLoading,
            onClick: handleManage,
            className: "settings--org-subs--manage-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}

            ,  !isManageLoading && _react2.default.createElement('img', { src: "/assets/icons/gear-outlined-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}} ) , "Manage billing"

          )
        )
      )
      , _react2.default.createElement('div', { className: "settings--org-subs--features", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        ,  renderContent() 
      )
      , _react2.default.createElement('div', { className: "settings--org-subs--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
        , _react2.default.createElement('span', { className: "settings--org-subs--footer--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, "Interested in learning more?"

        )
        , _react2.default.createElement('a', { href: supportUrl, target: "_blank", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
          , _react2.default.createElement(_Form.Button, { isInverted: true, className: "settings--org-subs--footer--btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}, "Talk to an expert"

          )
        )
      )
    )
  )
}

exports. default = Wrapper
